// extracted by mini-css-extract-plugin
export default {"button":"NotesButton_button__iZDOi"};